import { ChevronDown, MapPin } from 'lucide-react';
import { countries } from '../data/demo';
import { useCountry } from '../context/CountryContext';
import type { CountryCode } from '../types';

export function CountrySelector({ compact = false }: { compact?: boolean }) {
  const { country, setCountryCode } = useCountry();
  return <label className={`focus-within:ring-2 focus-within:ring-lime/30 relative flex items-center gap-2 rounded-xl border border-soft bg-white/[.045] ${compact ? 'px-3 py-2' : 'px-4 py-3'}`}>
    {compact ? <span>{country.flag}</span> : <MapPin size={17} className="text-lime" />}
    <span className="sr-only">Country</span>
    <select aria-label="Choose country" className="min-w-0 cursor-pointer appearance-none bg-transparent pr-5 text-sm font-bold outline-none" value={country.code} onChange={(event) => setCountryCode(event.target.value as CountryCode)}>
      {countries.map((item) => <option className="bg-[#10241a]" key={item.code} value={item.code}>{item.flag} {item.name}</option>)}
    </select>
    <ChevronDown size={14} className="pointer-events-none absolute right-3 text-muted" />
  </label>;
}
